// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { Base64 } from '../../../utils/base64';
import type { ExcludeMethodsDeep } from '../../../utils/types';

export class UploadFileInput {
  readonly fileName: string;
  readonly file: Base64;

  constructor(data: { [key: string]: any } = {}) {
    this.fileName = data.fileName === undefined ? '' : data.fileName;
    this.file = data.file === undefined ? '' : data.file;
  }

  static zero(): UploadFileInput {
    const zeroValues: ExcludeMethodsDeep<UploadFileInput> = {
      fileName: '',
      file: '',
    };
    return new UploadFileInput(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type UploadFileInputWireFormat = {
  fileName: string;
  file: string;
};

type NewUploadFileInputProps = PartialDeep<UploadFileInput, { recurseIntoArrays: true }>;
export const NewUploadFileInput: (props: NewUploadFileInputProps) => UploadFileInput = (props) =>
  new UploadFileInput(props);

type NewUploadFileInputFromWireFormatProps = PartialDeep<
  UploadFileInputWireFormat,
  { recurseIntoArrays: true }
>;
export const NewUploadFileInputFromWireFormat: (
  props: NewUploadFileInputFromWireFormatProps,
) => UploadFileInput = (props) => new UploadFileInput(props);
